import { ReactElement } from 'react'
import {
  GoalSectionEmptyStateContainer,
  IconContainer,
  Message,
} from './EmptyStates.styled'

type GoalSectionEmptyStateProps = {
  icon: ReactElement
  message: string
  simple?: boolean
}

export const GoalSectionEmptyState = ({
  icon,
  message,
  simple,
}: GoalSectionEmptyStateProps) => (
  <GoalSectionEmptyStateContainer simple={simple}>
    <IconContainer>{icon}</IconContainer>
    <Message>{message}</Message>
  </GoalSectionEmptyStateContainer>
)
